import React, { useEffect, useState } from "react";
import "./Edit.css";
import { InputText } from "primereact/inputtext";
import { Main_Color } from "./../../../Theme/Theme";
import { AiFillCloseCircle } from "react-icons/ai";
import Backend from "../../../Backend/Backend";
import ReactLoading from "react-loading";
import { MultiSelect } from "primereact/multiselect";
import { useAlert } from "react-alert";
import { Checkbox } from "primereact/checkbox";
const backend = new Backend();
const Edit = (props) => {
  const [name, setName] = useState(props.data.name);
  const [mobile, setMobile] = useState(props.data.mobile);
  const [password, setPassword] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [route, setRoute] = React.useState(props.route);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [adminid, setAdminid] = useState(localStorage.getItem("adminid"));
  const [alert_type, setAlert_type] = useState(localStorage.getItem("adminid"));
  const [loading, setLoading] = useState(false);
  const [accountState, setAccountState] = useState(
    props.data.status === "1" ? true : false
  );
  useEffect(() => {
    var myArray = props.data.route.split(",");
    setRoutes(myArray);
  }, []);

  const alert = useAlert();

  const _edit_worker = () => {
    if (name === "") {
      setAlert_type(1);
      setTimeout(() => {
        setAlert_type(0);
      }, 5000);
    } else if (mobile.length < 10) {
      setAlert_type(2);
      setTimeout(() => {
        setAlert_type(0);
      }, 5000);
    } else {
      let text = routes.join();
      let data = {
        worker_name: name,
        mobile: mobile,
        password: password,
        token: token,
        admin_id: adminid,
        worker_id: props.data.id,
        status: accountState,
        route: text,
      };
      setLoading(true);
      backend.edit_worker(data).then((r2) => {
        setLoading(false);
        if (r2.error === "False") {
          props.close();
          alert.show(r2.message);
        } else {
          alert.show(r2.message);
        }
      });
      backend.edit_worker_route(data).then((r2) => {
        if (r2.error === "False") {
          props.close();
          alert.show(r2.message);
        } else {
          alert.show(r2.message);
        }
      });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        height: "100vh",
      }}
    >
      <div
        style={{
          height: "80%",
          width: "55%",
          backgroundColor: "#f2f2f2",
          borderRadius: 10,
          display: "flex",
          alignSelf: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: 20,
            justifyContent: "space-between",
            display: "flex",
            backgroundColor: Main_Color,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            color: "#ffffff",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: 22 }}>Edit Delivery Boy</div>
          <div onClick={() => props.close("a")}>
            <AiFillCloseCircle style={{ height: "40px", width: "40px" }} />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <div
              style={{
                padding: 10,
                justifyContent: "center",
                display: "flex",
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                color: "#ffffff",
                width: "100%",
              }}
            >
              <span
                className="p-float-label"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <MultiSelect
                  value={routes}
                  style={{ width: "70%", color: "black" }}
                  options={route}
                  onChange={(e) => {
                    setRoutes(e.value);
                  }}
                />
              </span>
            </div>

            <div
              style={{
                padding: 10,
                justifyContent: "center",
                display: "flex",
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                color: "#ffffff",
              }}
            >
              <span style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder="Worker Name"
                  style={{
                    width: "500px",
                    marginTop: 10,
                    borderWidth: alert_type === 1 ? 2 : 1,
                    borderColor: alert_type === 1 ? "red" : "",
                  }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {alert_type === 1 ? (
                  <div style={{ marginTop: 5, paddingLeft: 10, color: "red" }}>
                    {"Invalid Worker Name "}
                  </div>
                ) : null}
              </span>
            </div>
            <div
              style={{
                padding: 10,
                justifyContent: "center",
                display: "flex",
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                color: "#ffffff",
              }}
            >
              <span style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder="Mobile Number"
                  maxLength={10}
                  value={mobile}
                  min="0"
                  max="10"
                  pattern="[0-9]{2}"
                  style={{
                    width: "500px",
                    marginTop: 10,
                    borderWidth: alert_type === 2 ? 2 : 1,
                    borderColor: alert_type === 2 ? "red" : "",
                  }}
                  onChange={(e) => setMobile(e.target.value)}
                />
                {alert_type === 2 ? (
                  <div style={{ marginTop: 5, paddingLeft: 10, color: "red" }}>
                    {"Invalid Worker Mobile Number "}
                  </div>
                ) : null}
              </span>
            </div>
            <div
              style={{
                padding: 10,
                justifyContent: "center",
                display: "flex",
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                color: "#ffffff",
              }}
            >
              <span style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder="Password - Leave Blank For No Change"
                  type="password"
                  style={{
                    width: "500px",
                    marginTop: 10,
                  }}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </span>
            </div>
            <div
              style={{
                padding: 10,
                justifyContent: "flex-start",
                display: "flex",
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                color: "#ffffff",
                alignItems: "center",
                paddingLeft: "20%",
              }}
            >
              <Checkbox
                onChange={(e) => setAccountState(e.checked)}
                checked={accountState}
              ></Checkbox>
              <div
                style={{
                  color: accountState === true ? "green" : "red",
                  paddingLeft: 15,
                  fontSize: 18,
                  fontWeight: "bold",
                }}
              >
                {accountState == true ? "Active" : "Deactive"}
              </div>
            </div>
            {loading === true ? (
              <div
                style={{
                  alignSelf: "center",
                  marginTop: 40,
                  height: "50px",
                  width: "200px",
                  backgroundColor: Main_Color,
                  borderRadius: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#ffffff",
                  fontSize: 18,
                }}
              >
                <ReactLoading
                  type={"bars"}
                  color={"#fff"}
                  height={45}
                  width={45}
                />
              </div>
            ) : (
              <div
                onClick={() => _edit_worker()}
                style={{
                  alignSelf: "center",
                  marginTop: 40,
                  height: "50px",
                  width: "200px",
                  backgroundColor: Main_Color,
                  borderRadius: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#ffffff",
                  fontSize: 18,
                }}
              >
                Submit
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
